import { inject, Pipe, type PipeTransform } from '@angular/core';
import type { MainMenuItem } from './main-menu-config.type';
import { AUTH_SERVICE_INJECTION_TOKEN } from '../auth/auth-service-injection-token';
import type { AdminUserRole } from '../../backend/main';

@Pipe({
  name: 'filterMenuItemsByRole',
})
export class FilterMenuItemsByRolePipe implements PipeTransform {
  private readonly authService = inject(AUTH_SERVICE_INJECTION_TOKEN);

  transform(mainMenuItems: MainMenuItem<AdminUserRole>[]): MainMenuItem<AdminUserRole>[] {
    return mainMenuItems.filter(item => this.authService.hasRealmRole(item.role));
  }
}
